import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppContext } from 'context/AppContext';
import { Modal, Button, Checkbox } from 'antd';
import icon_success from 'images/new_pop_ups/success.svg';

const Success = (props) => {
    const appContext = useContext(AppContext);

    const location = useLocation();
    const navigate = useNavigate();

    const showModal = () => {
        props.setIsModalVisibleSuccess(true);
    };

    const handleOk = () => {
        const queryParams = new URLSearchParams(location.search)
        if(queryParams.has('uploaded')){
            queryParams.delete('uploaded')
            navigate(queryParams)
        }
        props.setIsModalVisibleSuccess(false);
    };

    const handleCancel = () => {
        props.setIsModalVisibleSuccess(false);
    };

    const onChange = (e) => {
        appContext.setIsShowAgainSuccess(e.target.checked);
    };

    return (
        <>
            {/* <Button type="primary" onClick={showModal}>
                Open Modal
            </Button> */}
            <Modal
                className="basic-modal success-modal"
                title=""
                visible={props.isModalVisibleSuccess}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
                closable={false}
                bodyStyle={{ height: 330, padding: '24px 40px 24px 40px' }}
                width={380}
            >
                <div className="icon-container">
                    <img
                        src={icon_success}
                        style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px'
                        }}
                    />
                </div>
                <div>
                    <div>
                        <p
                            className="header-title"
                            style={{ marginBottom: '30px', marginTop: '17px' }}
                        >
                            Success!
                        </p>
                        <p
                            className="p-desctiption"
                            style={{
                                marginBottom: '98px',
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px'
                            }}
                        >
                            Your data has been uploaded and you are
                            <br />
                            all set to start analyzing your data!
                            {/* Data set uploaded successfully. <br />
                            Click to get started. */}
                        </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <button
                            onClick={handleOk}
                            style={{ width: '100%', marginTop: '25px' }}
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                        >
                            OK
                        </button>
                        {/* <Checkbox
                            checked={appContext.isShowAgainSuccess}
                            onChange={onChange}
                            className="checkbox"
                        >
                            Don’t show this message again
                        </Checkbox> */}
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Success;
